<script>
export default {
  name: 'Upload',
  props: ['fileList', 'simple', 'value'],
  data() {
    return {
      privateFileList: [],
    }
  },
  watch: {
    fileList: {
      handler(val) {
        this.privateFileList = val || []
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.privateFileList = val || []
      },
      immediate: true,
    },
  },
  created() {
    console.log(this.$attrs)
  },
  methods: {
    upload() {
      const input = document.createElement('input')
      input.style.display = 'none'
      input.type = 'file'
      input.onchange = e => {
        this.privateFileList = [...this.privateFileList, ...e.target.files]
        this.$emit('update:fileList', this.privateFileList)
        this.$emit('change', this.privateFileList)
      }
      document.documentElement.appendChild(input)
      input.click()
    },
    drop(e) {
      e.preventDefault()
      this.privateFileList = [...this.privateFileList, ...e.dataTransfer.files]
      this.$emit('update:fileList', this.privateFileList)
      this.$emit('change', this.privateFileList)
    },
    remove(index) {
      this.privateFileList.splice(index, 1)
      this.$emit('update:fileList', this.privateFileList)
      this.$emit('change', this.privateFileList)
    },
    count() {
      this.$set(this.$data, 'per', 0)
      setInterval(() => {
        this.per += 1
      }, 100)
      return this.per
    },
  },
  render() {
    const files = this.privateFileList.map((file, index) => (
      <div class="w-100 position-relative d-flex" style="align-items: center">
        <a-icon type="paper-clip" style="font-size: 18px" />
        <span class="ml-2">{file.name}</span>
        <a-icon type="close" class="cursor-pointer" style="margin-left: auto" onClick={() => this.remove(index)} />
        <a-progress
          class="position-absolute"
          style="bottom: -10px; left: 26px; width: calc(100% - 14px)"
          size="small"
          percent={100}
        />
      </div>
    ))
    if (this.simple) {
      return (
        <div class="position-relative">
          <a-button icon="upload" onClick={this.upload}>
            {this.$t('upload')}
          </a-button>
          <div class="d-flex" style="flex-direction: column; align-items: center">
            {files}
          </div>
        </div>
      )
    }
    return (
      <div class="w-10" style="margin: 0 auto;">
        <div
          class="h-4 hover bd bg text-align-center cursor-pointer"
          onClick={this.upload}
          onDragover={e => e.preventDefault()}
          onDrop={this.drop}
        >
          <a-icon type="inbox" class="icon mt-5" />
          <p class="text-black-1 mt-2 mb-0">{this.$t('page_my_document_upload_here')}</p>
          <p class="text-black-3 mt-1 mb-0">{this.$t('page_firmware_management_support_extend')}：.xls、.xlsx</p>
        </div>
        <div class="d-flex" style="flex-direction: column; align-items: center">
          {files}
        </div>
      </div>
    )
  },
}
</script>

<style lang="less" scoped>
@import '~ant-design-vue/lib/style/themes/default.less';
@gray-2: #fafafa;
@gray-5: #d9d9d9;
@black-1: rgba(0, 0, 0, 0.85);
@black-3: rgba(0, 0, 0, 0.45);
.hover {
  transition: border cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &:hover {
    border-color: @blue-5;
  }
}
.bd {
  border: 1px dashed @gray-5;
  border-radius: 4px;
}
.bg {
  background: @gray-2;
}
.text-black-1 {
  font-size: 16px;
  color: @black-1;
}
.text-black-3 {
  color: @black-3;
}
.icon {
  color: @blue-6;
  font-size: 48px;
}
.text-align-center {
  text-align: center;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
